import { CONTEST_LIST_DATA, CONTEST_LIST_ERROR, CONTEST_LIST_FETCH } from './constants';
import { ContestListDataAction, ContestListErrorAction, ContestListFetchAction, ContestListItem } from './types';

export const contestListFetch = (): ContestListFetchAction => ({
    type: CONTEST_LIST_FETCH,
});

export const contestListData = (items: ContestListItem[]): ContestListDataAction => ({
    type: CONTEST_LIST_DATA,
    payload: items,
});

export const contestListError = (error: any): ContestListErrorAction => ({
    type: CONTEST_LIST_ERROR,
    payload: error,
});


